<template>
    <div class="d-flex p-0 mr-0 mt-4 g-3 align-items-center address" :class="{'mt-0': this.first, 'flex-column': labelTop}">
        <div class="d-flex align-items-center mb8" :class="{ 'col-6': !labelTop, 'col-12': labelTop }">
            <label :for="id" class="mt-0 pl-0 pt-0 pb-0" :class="{ 'primary-grey': !labelTop, 'fsp14 lh20': labelTop }">
                {{this.label}}
                <span class='require' v-if="this.require"> *</span>
            </label>
            <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper>
        </div>
        <div class="mt-0 p-0 address-wrapper d-flex align-items-center gap-2" :class="{ 'col-6': !labelTop, 'col-12': labelTop, 'm-0': labelTop }">
            <div class="address-input-wrap">
                <InputSimple
                    :id="id + '_select'"
                    :dataValue="this.dField.value_text"
                    :disabled="true"
                    :hotUpdate="true"
                >
                    <button
                        v-if="!this.disabled"
                        class="edit-btn neue fsp14"
                        @click="this.showParams"
                    >
                        <Icon name="pencil" class="c16" />
                        {{ $t('components.service.modal.Address.19') }}
                    </button>
                </InputSimple>
            </div>
            <Popper
                v-if="this.verification"
                :id="id + '_check'"
                :hover="true"
            >
                <Icon name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                <template #content>
                    <span>{{ $t('views.InfoReg.3') }}</span>
                </template>
            </Popper>
            <Popper v-if="this.unvisible" :hover="true" :id="id + '_va'">
                <button
                    type="button"
                    class="btn btn-outline-grey eye-toggle"
                    :disabled="this.is_public == '2'"
                    @click="toggleUnvisible"
                >
                    <Icon :name="unvisibleValue === '1' ? 'eye' : 'eye-off'" size="c20" />
                </button>
                <template #content>
                    <span>{{ $t(unvisibleValue === '1' ? 'views.InfoReg.4' : 'views.InfoReg.5') }}</span>
                </template>
            </Popper>
        </div>
    </div>
</template> 

<script>
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';
import InputSimple from '@/components/service/InputSimple';

export default {
    components: {
        Tooltip,
        Icon,
        Popper,
        InputSimple
    },
    data() {
        return {
            addr_v: this.addr ? this.addr : {},
            dField: this.field ? this.field : {},
            sizeW: this.$store.state.resize.w,
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
        }
    },
    props: {
        first: {
            type: Boolean,
            default: false,
        },
        id: [String, Boolean],
        label: [String],
        hint: [String, Boolean],
        addr: [Object, Boolean], 
        field: [Object, Boolean], 
        require: [Boolean],
        disabled: [String, Boolean],
        invalid: [Boolean],
        invalidHint: [String, Boolean],
        unvisible: [Boolean],
        unvisibleDataValue: [String, Boolean], 
        vMark: [Boolean],
        is_public: [Boolean, String],
        verification: [Boolean],
        getAddress: [String],
        labelTop: [Boolean],
    },
    methods: {
        findAddressValue(data) {
            // Проверяем: data массив или объект
            if (Array.isArray(data)) {
                for (const item of data) {
                    const result = this.findAddressValue(item);
                    if (result) {
                        return result;
                    }
                }
            } else if (typeof data === 'object' && data !== null) {
                // Если это объект, проверяем его ключи
                if (data.key === 'address') {
                    return data.value;
                }
                // Рекурсивно проверяем все значения объекта
                for (const key in data) {
                    const result = this.findAddressValue(data[key]);
                    if (result) {
                        return result;
                    }
                }
            }
            return null;
        },
        getlistAddress(valText) {
            if (valText || !this.dField?.value) {
                return;
            }

            this.axios.post('getlistAddress', {no_loader: true, data: {house: this.dField.value}}).then(res => {
                if (res.data.body.result == '0') {
                    const address = this.findAddressValue(res.data.body.tables);
                    this.dField.value_text = address;
                }
            })
        },
        setValue(arg) {
            // console.log('setValue address not modal', arg);
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.value
            })
        },
        setTextValue(arg) {
            this.$emit('updateParentTextState', {
                id: arg.id,
                value: arg.value
            })
        },
        toggleUnvisible() {
            let newValue = this.unvisibleValue === '1' ? '0' : '1';
            this.unvisibleValue = newValue;
            this.$emit('updateParentState', {
                id: this.id,
                unvisible: true,
                value: newValue,
            });
        },
        showParams() {
            // console.log('showParams, addr_v', this.addr_v);
            this.$store.commit('MODAL', {
                    action: true,
                    type: 'address',
                    content: {
                        field: this.dField,
                        addr: this.addr_v,
                        updateState: (arg, text) => {
                            // console.log('updateState');
                            this.setValue(arg);
                            this.dField.value_text = text;

                            if (arg.new_addr) {
                                this.addr_v = arg.new_addr;
                            }
                        },
                    },
                    }
            );
        },
    },
    created() {
        this.getlistAddress(this.dField.value_text);
    }

}
</script>

<style lang="scss" scoped>
.address {
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }
}

.address-input-wrap {
    flex: 1;
    min-width: 0;

    :deep(.input-container) {
        padding: 4px 4px 4px 12px !important;
        height: auto !important;
        .mr8 {
            margin-right: 0 !important;
        }
    }

    :deep(.bg-light-grey) {
        background-color: #fff !important;
    }

    :deep(input:disabled) {
        background-color: #fff !important;
        color: #000 !important;
        -webkit-text-fill-color: #000;
    }
}

.edit-btn {
    background: $menu-bg;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 0 8px;
    height: 32px;
    white-space: nowrap;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    &:hover {
        background: $main-hover;
        filter: $btn-saturate;
    }
}

</style>
